import messageInformation from './messageInformation';

export default function messageSucces(message) {
  messageInformation(message, 'is-success');
}
